import $ from "jquery";
import * as Common from "../../../../common/common";
import * as CommonFunctions from "./commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import { WindowUtils } from "msal";

export default function standart() {}

export const  FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  if (page_number === 1) {
    oTable.fnClearTable();
    window.$catalog_work_resources_tableTotalpage = result.meta.total_pages;
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType =
          data.content["algemeen-actief"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var algemeenNaam =
          '<span class="text-dark font-weight-bold">' +
          data.content["algemeen-naam"] +
          "</span>";
        var algemeenCode = data.content["algemeen-code"];
        if (typeof algemeenCode === "undefined") {
          algemeenCode = "";
        } else algemeenCode = '<a href="javascript:void(0)">' + data.content["algemeen-code"] + "</a>";
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        var omschrijving = data.content["algemeen-omschrijving"];
        if (typeof omschrijving === "undefined") {
          omschrijving = "";
        }
        var kosteneenheid = data.content["algemeen-kosteneenheid"];
        if (typeof kosteneenheid === "undefined") {
          kosteneenheid = "";
        }
        var algemeenPrijs = data.content["algemeen-prijs"];
        if (typeof algemeenPrijs === "undefined") {
          algemeenPrijs = "";
        }
        var definitionType = data.relationships.definition["code"];
        if (typeof definitionType === "undefined") {
          definitionType = "";
        }

        var datumAangemaakt = data["timestamp_created"];
        if (typeof datumAangemaakt === "undefined") {
          datumAangemaakt = "";
        } else datumAangemaakt = Common.FormatDate(datumAangemaakt, "date");
        var datumLaatstGewijzigd = data["timestamp_any_update"];
        if (typeof datumLaatstGewijzigd === "undefined") {
          datumLaatstGewijzigd = "";
        } else datumLaatstGewijzigd = Common.FormatDate(datumLaatstGewijzigd, "date");

        let aantalbijlagen = data.content["algemeen-aantalbijlagen"];
        if (typeof aantalbijlagen === "undefined") {
          aantalbijlagen = "";
        }

        var model = {
          algemeenNaam: data.content["algemeen-naam"],
          algemeenCode: data.content["algemeen-code"],
          aantalbijlagen: aantalbijlagen,
          omschrijving: data.content["algemeen-omschrijving"],
          kosteneenheid: data.content["algemeen-kosteneenheid"],
          datumAangemaakt: datumAangemaakt,
          datumLaatstGewijzigd: datumLaatstGewijzigd,
          isActive: data.content["algemeen-actief"],
          identification: data["identification"],
          definitionType: definitionType,
          algemeenPrijs: algemeenPrijs,
        };

        var test = {
          checkbox: checkbox,
          active: circleType,
          Naam: algemeenNaam,
          Code: algemeenCode,
          paperclip: aantalbijlagen,
          Omschrijving: omschrijving,
          // Type: definitionType,
          Prijs: algemeenPrijs,
          Kosteneenheid: kosteneenheid,
          "Datum aangemaakt": datumAangemaakt,
          "Datum laatst gewijzigd": datumLaatstGewijzigd,
        };

        let _columnList = [];
        if (columnList && columnList.column_list){
          for (let column in columnList.column_list) {
            for (let key in test) {
              if (
                  columnList.column_list[column].toLowerCase() === key.toLowerCase()
              ) {
                _columnList.push(test[key]);
              }
            }
          }
        }

        window.$catalog_work_resources_Glist.push(model);
        var addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // circleType,
            // algemeenNaam,
            // algemeenCode,
            // aantalbijlagen,
            // omschrijving,
            // definitionType,
            // algemeenPrijs,
            // kosteneenheid,
            // datumAangemaakt,
            // datumLaatstGewijzigd,
          ],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }
  window.$catalog_work_resources_tableTotalpage = result.meta.total_pages;

  $("#total-rows").html(result.meta.total_found);
  window.$catalog_work_resources_table_total_row_count =
    result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$catalog_work_resources_treeChangeStatus = true;
  window.$catalog_work_resources_units_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-code") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_resources_algemeenCode.push(data);
    });
  } else if (data.id === "algemeen-naam") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_resources_algemeenNaam.push(data);
    });
  } else if (data.id === "algemeen-kosteneenheid") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_resources_algemeenKosteneenheid.push(data);
    });
  } else if (data.id === "algemeen-omschrijving") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_resources_algemeenOmschrijving.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-naam") {
    console.log(result.data.values);
    window.$catalog_work_resources_algemeenNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_resources_algemeenNaam.push(data);
    });
  } else if (searchId === "algemeen-code") {
    window.$catalog_work_resources_algemeenCode.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_resources_algemeenCode.push(data);
    });
  } else if (searchId === "algemeen-kosteneenheid") {
    window.$catalog_work_resources_algemeenKosteneenheid.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_resources_algemeenKosteneenheid.push(data);
    });
  } else if (searchId === "algemeen-omschrijving") {
    window.$catalog_work_resources_algemeenOmschrijving.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_resources_algemeenOmschrijving.push(data);
    });
  }
};

export const WerkbronSavedCallBack = (token) => {
  Common.sleep(800).then(() => {
    $("#werkbron_toevoegen_modal").modal("hide");
    window.$catalog_work_resources_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_work_resources_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const WerkbronEditCallBack = (token) => {
  Common.sleep(800).then(() => {
    $("#detailSide").addClass("d-none");
    $("#editSide").addClass("d-none");
    $("#tableSide").removeClass("d-none");
    window.$catalog_work_resources_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_work_resources_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const RowsDeletedCallBack = (token) => {
  Common.sleep(800).then(() => {
    $("#work-resource-mappen_beheren_delete_modal").modal("hide");
    window.$catalog_work_resources_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_work_resources_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetColumnPropertiesCallBack = (data, callType) => {
  var filteredRes = data.data.find((item, i) => {
    if (item.identification === process.env.REACT_APP_CATALOG_WORK_RESOURCES) {
      return i;
    }
  });

  // var result_data = data.data[8].schema.properties.algemeen.properties;
  var result_data = filteredRes.schema.properties.algemeen.properties;
  window.$catalog_work_resources_column_list.forEach(function (item) {
    if (item.haveSelect) {
      if (callType == "create") {
        const selectStatus = document.getElementById(item.createId);
        if (selectStatus) {
          while (selectStatus.firstChild) {
            selectStatus.removeChild(selectStatus.lastChild);
          }
        }
        result_data[item.selectProperties].enum.forEach((element) => {
          var option = document.createElement("option");
          option.text = element;
          option.value = element;
          selectStatus.add(option);
        });
      } else if (callType == "edit") {
        const editSelectStatus = document.getElementById(item.editId);
        if (editSelectStatus && editSelectStatus.firstChild != null) {
          while (editSelectStatus.firstChild) {
            editSelectStatus.removeChild(editSelectStatus.lastChild);
          }
        }
        result_data[item.selectProperties].enum.forEach((element) => {
          if (item.editId) {
            var option = document.createElement("a");
            option.attributes.href = "javascript:void(0)";
            option.className = "popuptext-dropdown-a";
            option.name = item.editId;
            option.innerText = element;
            editSelectStatus.appendChild(option);
          }
        });
      }
    }
  });
  // CommonFunctions.GetRowOfDetail(window.$catalog_work_resources_row_id);
};

export const GetColumnPropertiesForModelCallBack = (
  result,
  itemId,
  callType
) => {
  window.$catalog_measures_column_list.forEach(function (item) {
    if (item.id === itemId) {
      if (callType == "create") {
        const selectStatus = document.getElementById(item.createId);
        while (selectStatus.firstChild) {
          selectStatus.removeChild(selectStatus.lastChild);
        }
        var option = document.createElement("option");
        option.text = "Selecteer";
        option.style = "display:none;";
        selectStatus.add(option);
        result.data.forEach((element) => {
          var option = document.createElement("option");
          option.text = element.name;
          option.value = element.identification;
          selectStatus.add(option);
        });
      } else if (callType == "edit") {
        const editSelectStatus = document.getElementById(item.editId);
        if (editSelectStatus && editSelectStatus.firstChild != null) {
          while (editSelectStatus.firstChild) {
            editSelectStatus.removeChild(editSelectStatus.lastChild);
          }
        }
        result.data.forEach((element) => {
          if (item.editId) {
            var option = document.createElement("a");
            option.attributes.href = "javascript:void(0)";
            option.className = "popuptext-dropdown-a";
            option.name = item.editId;
            option.innerText = element.name;
            option.id = element.identification;
            editSelectStatus.appendChild(option);
          }
        });
      }
    }
  });
};

export const GebiedenCallback = (result) => {
  $("#gebieden-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="gebieden"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '"/>';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#gebieden-grp").append(btn);
  });
};

export const UitvoerderCallback = (result) => {
  $("#koppelen-uitvoerder-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="uitvoerder"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#koppelen-uitvoerder-grp").append(btn);
  });
};

export const GrootboekCallback = (result) => {
  $("#grootboeknummer-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="uitvoerder"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#grootboeknummer-grp").append(btn);
  });
};
export const GrootboekCallbackForCreateMaat = (result) => {
  const selectStatus = document.getElementById("maatregelen-grootboek-nummer");
  while (selectStatus.firstChild) {
    selectStatus.removeChild(selectStatus.lastChild);
  }
  var option = document.createElement("option");
  option.text = "Selecteer";
  option.style = "display:none;";
  selectStatus.add(option);

  if (result.meta.total_found.length > 0) {
    result.data.forEach((element) => {
      var option = document.createElement("option");
      option.text = element.name;
      option.value = element.identification;
      selectStatus.add(option);
    });
  }
};
export const GrootboekCallbackForEditMaat = (result) => {
  const editSelectStatus = document.getElementById("e-grootboek-nummer");
  if (editSelectStatus && editSelectStatus.firstChild != null) {
    while (editSelectStatus.firstChild) {
      editSelectStatus.removeChild(editSelectStatus.lastChild);
    }
  }
  result.data.forEach((element) => {
    var option = document.createElement("a");
    option.attributes.href = "javascript:void(0)";
    option.className = "popuptext-dropdown-a";
    option.name = "e-grootboek-nummer";
    option.innerText = element.name;
    option.id = element.identification;
    editSelectStatus.appendChild(option);
  });
};
export const DisciplineCallbackForCreateMaat = (result) => {
  const selectStatus = document.getElementById("maatregelen-discipline");
  while (selectStatus.firstChild) {
    selectStatus.removeChild(selectStatus.lastChild);
  }
  var option = document.createElement("option");
  option.text = "Selecteer";
  option.style = "display:none;";
  selectStatus.add(option);

  result.data.forEach((element) => {
    var option = document.createElement("option");
    option.text = element.name;
    option.value = element.identification;
    selectStatus.add(option);
  });
};
export const DisciplineCallbackForEditMaat = (result) => {
  const editSelectStatus = document.getElementById("e-discipline");
  if (editSelectStatus && editSelectStatus.firstChild != null) {
    while (editSelectStatus.firstChild) {
      editSelectStatus.removeChild(editSelectStatus.lastChild);
    }
  }
  result.data.forEach((element) => {
    var option = document.createElement("a");
    option.attributes.href = "javascript:void(0)";
    option.className = "popuptext-dropdown-a";
    option.name = "e-discipline";
    option.innerText = element.name;
    option.id = element.identification;
    editSelectStatus.appendChild(option);
  });
};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];

  $.each(result.data.stages, function (index, stage) {
    if (stage.definition.type === "activity" && stage.start_allowed === true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });

  $("#myPopup").html("");
  $.each(window.$catalog_work_resources_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " catalog-work-resources-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });
  //** aktif olmayan actionlar burada listeleniyor. */
  // $.each(actionsOfDisabled, function (index, action) {
  //   var anchor = $("<a disabled></a>")
  //     .attr({ href: "javascript:void(0)", id: action["identification"] })
  //     .addClass("disabled" + " catalog-action")
  //     .html(action["name"]);
  //   $("#myPopup").append(anchor);
  // });
  if (result.data.stages.length > 0) {
    var verwijderen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "work-resource-verwijderen" })
      .addClass("trash-bin beheereenheid")
      .html("Verwijderen");
    $("#myPopup").append(verwijderen);
  } else {
    var beheereenheidToevoegen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "werkbron_toevoegen" })
      .addClass("locate beheereenheid")
      .html("Werkbron toevoegen");
    $("#myPopup").append(beheereenheidToevoegen);
  }

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";
  let paperIndex = test_list.findIndex((x) => x.includes("bijlage"));
  test_list[paperIndex] = "paperclip";
  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "catalog>work-resources",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "catalog>work-resources"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
